
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class ImBubbles2Icon extends Vue {}
